import { render, staticRenderFns } from "./FBMAdminFields.vue?vue&type=template&id=fea00de0&scoped=true"
import script from "./FBMAdminFields.vue?vue&type=script&lang=js"
export * from "./FBMAdminFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea00de0",
  null
  
)

export default component.exports